import React from "react";

import Button, { ButtonProps } from "../../button/Button";
import { Trash } from "../../svg/svgImageList";
import useThemService from "../../../services/theme-service/ThemeService";
import useModal from "../../dialog/useModal";
import WarningBeforeAction from "../../data-components/WarningBeforeAction";
import { TranslationContext } from "../../../services/translation/TranslationService";

interface DeleteButtonProps extends ButtonProps {
  disabled?: boolean;
  confirmationModalTitleKey: string;
  confirmationModalTitleContext?: TranslationContext;
  confirmationModalSubtitleKey: string;
  canUserRestoreDeletedEntity?: boolean;
  confirmationAction: () => void;
}

export default function DeleteButton(props: DeleteButtonProps) {
  const { themeClass } = useThemService();
  const { toggleModal, isVisible } = useModal();

  const {
    disabled,
    confirmationAction,
    confirmationModalTitleKey,
    confirmationModalTitleContext,
    confirmationModalSubtitleKey,
    canUserRestoreDeletedEntity,
    tooltipKey: tooltip,
  } = props;

  const handleConfirmationAction = () => {
    confirmationAction();
    toggleModal();
  };

  return (
    <>
      <Button
        id="delete"
        disabled={disabled}
        onClick={toggleModal}
        tooltipKey={tooltip}
        icon={{
          svg: Trash,
          textKey: "general.delete",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-trash"]),
        }}
      />
      <WarningBeforeAction
        isVisible={isVisible}
        titleKey={confirmationModalTitleKey}
        titleContext={confirmationModalTitleContext}
        subtitleKey={confirmationModalSubtitleKey}
        canUserRestoreDeletedEntity={canUserRestoreDeletedEntity}
        buttonOk={{
          id: "delete-ok",
          textKey: "general.delete",
          action: handleConfirmationAction,
        }}
        toggleModal={toggleModal}
      />
    </>
  );
}
